import classnames from 'clsx';
import type { IStyles } from 'playable/dist/src/modules/ui/core/types';
import * as React from 'react';
import BasicButton from '../../SiteButton/viewer/skinComps/BaseButton/BasicButton.skin';
import type {
  IIFrameConfig,
  IOnBackendSocialLogin,
} from '../MemberLoginDialog.types';
import { useHeadlessPopup } from './useHeadlessPopup';

export type HeadlessAuthButtons = {
  style: IStyles;
  error?: string;
  iframeConfig: IIFrameConfig;
  loginUrl: string;
  externalBaseUrl?: string;
  onBackendSocialLogin: IOnBackendSocialLogin;
  onSocialError: (error: string) => void;
};

export const HeadlessAuthButtons: React.FC<HeadlessAuthButtons> = ({
  loginUrl,
  style,
  onBackendSocialLogin,
  onSocialError,
  iframeConfig,
  externalBaseUrl,
  error, // Will be set to a non-empty string if an error was thrown during social auth
}) => {
  const loginCallbackUrl = '/_api/iam/authentication/v1/callback';
  const openPopup = useHeadlessPopup(
    iframeConfig,
    onBackendSocialLogin,
    onSocialError,
    externalBaseUrl
      ? `${externalBaseUrl}${loginCallbackUrl}`
      : loginCallbackUrl,
  );

  return (
    <div className={style.socialLoginWrapper}>
      <div
        data-testid="headless-auth-buttons"
        className={classnames(style.socialButton, style.sso)}
      >
        <BasicButton
          label="Sign in"
          id="headless_sign_in"
          link={undefined}
          hasPlatformClickHandler={true}
          isDisabled={false}
          onClick={() => openPopup(loginUrl)}
        />
      </div>
      <p className={style.socialLoginErrorMsg}>{error}</p>
    </div>
  );
};
